import styled from 'styled-components'
import Box from 'UIKit/Box/Box'
import { BoxProps } from 'UIKit/Box/types'
import { TableCellHistory } from 'UIKit/Table/TableHistory'
import TableRow from 'UIKit/Table/TableRow'

const EmptyRow: React.FC<BoxProps> = ({ ...props }) => {
  return (
    <TableRow {...props}>
      <StyledTableCell style={{ display: 'flex', justifyContent: 'center' }}>
        <Box width="24px" height="24px" borderRadius="50%" background="transparent" />
      </StyledTableCell>
      <StyledTableCell>
        <StyledEmptyContentBlock />
      </StyledTableCell>

      <StyledTableCell>
        <StyledEmptyContentBlock />
      </StyledTableCell>

      <StyledTableCell>
        <StyledEmptyContentBlock />
      </StyledTableCell>
    </TableRow>
  )
}

const StyledEmptyContentBlock = styled(Box)`
  border-radius: 21px;
  height: 8px;
  background: transparent;
  width: 70%;
`

const StyledTableCell = styled(TableCellHistory)`
  padding: 6px 12px;
  min-height: 32px;
`

export default EmptyRow
